import moment from "moment";
import { strings } from "../../utils/constants";

// Client-side validation constants. The backend remains authoritative.
export const MAX_DURATION_SECONDS = 90;
export const ACCEPTED_MIME = "video/mp4";
export const ACCEPTED_EXTENSION = ".mp4";

/** Format a byte count into a human-readable string. */
export const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "-";
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

/** Format seconds into mm:ss. */
export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return "-";
  const total = Math.round(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};

/** Format an ISO/date string using the app's moment dependency. */
export const formatDate = (value) => {
  if (!value) return "-";
  const m = moment(value);
  return m.isValid() ? m.format("DD MMM YYYY, hh:mm A") : "-";
};

/** Validate that the selected file is an MP4 by MIME type and extension. */
export const isMp4 = (file) => {
  if (!file) return false;
  const nameOk = file.name?.toLowerCase().endsWith(ACCEPTED_EXTENSION);
  const typeOk = file.type === ACCEPTED_MIME || file.type === "";
  return nameOk && typeOk;
};

/**
 * Read video duration (seconds) from browser metadata without uploading.
 * Resolves with the duration; rejects if metadata cannot be read.
 * The caller is responsible for revoking any object URL it created.
 */
export const readVideoDuration = (objectUrl) =>
  new Promise((resolve, reject) => {
    const videoEl = document.createElement("video");
    videoEl.preload = "metadata";
    videoEl.onloadedmetadata = () => {
      const duration = videoEl.duration;
      videoEl.onloadedmetadata = null;
      if (isFinite(duration) && duration > 0) {
        resolve(duration);
      } else {
        reject(new Error(strings.admin.error.VIDEO_METADATA_FAILED));
      }
    };
    videoEl.onerror = () => {
      reject(new Error(strings.admin.error.VIDEO_METADATA_FAILED));
    };
    videoEl.src = objectUrl;
  });
